import { Sidebar } from "@xola/ui-kit";
import React from "react";
import { MenuItem } from "./MenuItem";
import { getPermissions } from "@/stores/globalStore";

export const DistributionMenuItems = () => {
    const permissions = getPermissions(); // Fetch permissions using getPermissions

    return (
        <>
            {permissions.canViewAffiliates && <MenuItem isSubMenuItem route="distribution/agents" label="Agents" />}
            {permissions.canViewOperators && (
                <MenuItem isSubMenuItem route="distribution/operators" label="Operators" />
            )}
            {(permissions.canViewOperators || permissions.canViewAffiliates) && (
                <>
                    <Sidebar.Separator />
                    <MenuItem isSubMenuItem route="distribution/termsTemplates" label="Terms Templates" />
                </>
            )}
            {permissions.canViewDistributionProfile && (
                <MenuItem isSubMenuItem route="distribution/profile" label="Distribution Profile" />
            )}
        </>
    );
};
